var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLeaderboardLeftArrow({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 40,
    viewBox: "0 0 41 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.22 20.7199C16.0793 20.5793 16.0002 20.3887 16 20.1899V19.8099C16.0023 19.6114 16.0811 19.4216 16.22 19.2799L21.36 14.1499C21.4539 14.0552 21.5817 14.002 21.715 14.002C21.8483 14.002 21.9761 14.0552 22.07 14.1499L22.78 14.8599C22.8741 14.952 22.9271 15.0782 22.9271 15.2099C22.9271 15.3415 22.8741 15.4677 22.78 15.5599L18.33 19.9999L22.78 24.4399C22.8747 24.5337 22.9279 24.6615 22.9279 24.7949C22.9279 24.9282 22.8747 25.056 22.78 25.1499L22.07 25.8499C21.9761 25.9445 21.8483 25.9978 21.715 25.9978C21.5817 25.9978 21.4539 25.9445 21.36 25.8499L16.22 20.7199Z",
    fill: "#0E9384"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeaderboardLeftArrow);
export default __webpack_public_path__ + "static/media/Leaderboard_Left_Arrow.379dcdb76f397a239c9ae29e273bd3ac.svg";
export { ForwardRef as ReactComponent };